export const normalizeNumbers = (val: number, minmax: [number, number]) => {
    const [min, max] = minmax;

    if (max === min) {
        return 1;
    }

    return (val - min) / (max - min);
};
